import { useState, useEffect, useRef } from 'react';
import { FaArrowUp } from 'react-icons/fa6';
import TaraLogo from '../../../assets/images/chatLogo.svg';
import { IoMdClose } from 'react-icons/io';

type AiPromptProps = {
  open: boolean;
  onClose: () => void;
};

export default function AiPrompt({ open, onClose }: AiPromptProps) {
  const [message, setMessage] = useState('');
  const [logs, setLogs] = useState<string[]>([
    'Welcome! AI Recruitment Agent initialized.',
  ]);
  const logsEndRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    logsEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs]);

  if (!open) return null;

  const sendMessage = () => {
    if (!message.trim()) return;
    setLogs((prev) => [...prev, `You: ${message}`]);
    setMessage('');
    setTimeout(() => {
      setLogs((prev) => [...prev, `AI: Response to "${message}"`]);
    }, 500);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/20 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col min-h-[450px] p-6 shadow-[#F8F5FF]">
        <div className=" flex items-center justify-between gap-3">
          <h1 className="text-xl font-semibold flex-1">AI Recruitment Agent</h1>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-8 h-8 rounded-full  text-slate-500 flex items-center justify-center text-lg transition-colors hover:text-red-500"
          >
            <IoMdClose />
          </button>
        </div>
        <hr className="h-[0.5px] border-0 bg-[#D7D7D7] my-2" />
        <div className=" py-4 flex-1 overflow-y-auto flex flex-col gap-2">
          {logs.map((log, i) => (
            <div
              key={i}
              className={`text-sm px-3 py-2 rounded-lg max-w-[75%] ${
                log.startsWith('AI:')
                  ? 'bg-violet-50 text-violet-700 self-start'
                  : 'bg-gray-100 text-gray-800 self-end'
              }`}
            >
              {log}
            </div>
          ))}
          <div ref={logsEndRef} />
        </div>

        <div className="px-6 py-4 flex items-center gap-2">
          <div className="relative flex-1">
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Type your message..."
              className="w-full pr-16 pl-4 py-4 border rounded-lg text-sm focus:outline-none transition-colors border-[#E8E8E8]  bg-[#FFFFFF]"
            />

            <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2">
              <FaArrowUp
                size={18}
                className={`text-gray-400 cursor-pointer transition-opacity ${
                  message.trim()
                    ? 'opacity-100 hover:text-violet-600'
                    : 'opacity-40 pointer-events-none'
                }`}
                onClick={sendMessage}
              />
              <img
                src={TaraLogo}
                alt="Logo"
                className="w-8 h-8 rounded-full border border-[#E8E8E8]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
